import axios from 'axios';

import ConfigureHeaders from '../utils/ConfigureHeaders';

const baseURL = process.env.REACT_APP_NOTIFICACOES;

const notificacao = () => {
  const defaultOptions = {
    baseURL: `${baseURL}/api/v1`,
    headers: {
      Accept: 'application/json',
    },
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(config => ConfigureHeaders(config));

  return instance;
};

export default notificacao();
